// External
import { Component, OnInit, Input } from '@angular/core';
import { UiForm } from '../ui-form.models';

// Internal

@Component({
    selector: 'checkbox-control',
    template: `<ng-content select="input"></ng-content>
                <div class="control-div">
                    <ui-icon type="general" icon="mark" [size]="16" color="light" shape="icon"></ui-icon>
                </div>
                <div class="control-label">
                    <ng-content select="label"></ng-content>
                    <p class="hint" *ngIf="hint && (isValid === false || showHint)">{{hint}}</p>
                </div>`,
    host: {
      '[class.checkbox-control]': 'true',
      '[class.invalid]': 'isValid === false'
    }
})
export class CheckboxControlComponent implements UiForm.Checkbox.Component {
    @Input() isValid;
    @Input() hint;
    @Input() showHint = false;
}
